import React, {useEffect, useState} from "react";




export const ProfilePicture = () =>{
    return(
        <div
            className="circular--portrait"
        >
            <img src={'http://pkdservers.com/RPM/api/Content/Images/default.png'}/>
        </div>
    )
}